var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryStudy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6103 3H9.39398C7.52223 3 6.00488 4.56059 6.00488 6.48566V43.5143C6.00488 45.4394 7.52223 47 9.39398 47H40.6103C42.482 47 43.9994 45.4394 43.9994 43.5143V6.48566C43.9994 4.56059 42.482 3 40.6103 3Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9935 34.7221V43.5143C43.9935 45.4327 42.4697 47 40.6044 47H9.38812C7.52285 47 5.99902 45.4327 5.99902 43.5143V41.6934C5.99902 39.775 7.52285 38.2078 9.38812 38.2078H40.6044C42.4697 38.2078 43.9935 36.6405 43.9935 34.7221Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6027 39.4239V43.7809C42.6027 44.5028 42.0273 45.0946 41.3254 45.0946H9.4452C8.73704 45.0946 8.16797 44.5093 8.16797 43.7809V41.4073C8.16797 40.692 8.73704 40.0937 9.4452 40.0937H40.6046C41.3444 40.0937 42.0399 39.8401 42.5963 39.4174L42.6027 39.4239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9935 7.09698H13.0106C11.8862 7.09698 10.9746 8.0345 10.9746 9.19099V17.4694C10.9746 18.6259 11.8862 19.5634 13.0106 19.5634H36.9935C38.1179 19.5634 39.0295 18.6259 39.0295 17.4694V9.19099C39.0295 8.0345 38.1179 7.09698 36.9935 7.09698Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2265 22.0671H17.7723C17.3986 22.0671 17.0957 22.3787 17.0957 22.763C17.0957 23.1473 17.3986 23.4588 17.7723 23.4588H32.2265C32.6001 23.4588 32.903 23.1473 32.903 22.763C32.903 22.3787 32.6001 22.0671 32.2265 22.0671Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0467 45.9749L12.3332 45.3896C12.2699 45.3701 12.2004 45.3701 12.1308 45.3896L10.4173 45.9749C10.2086 46.0464 10 45.8903 10 45.6627V41H14.464V45.6627C14.464 45.8838 14.249 46.0464 14.0467 45.9749Z",
    fill: "#FF8B8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8083",
    x: 3.99902,
    y: 1,
    width: 42,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8083",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryStudy);
export default __webpack_public_path__ + "static/media/category_study.6f22b4017f0157422e79d7c09e9c11df.svg";
export { ForwardRef as ReactComponent };